"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import AwesomeDebouncePromiseImport from 'awesome-debounce-promise';

const AwesomeDebouncePromise = (
  // @ts-expect-error: ESM/CJS interop — default export may be nested under .default
  AwesomeDebouncePromiseImport?.default ?? AwesomeDebouncePromiseImport
);

export { AwesomeDebouncePromise as default };
